import dayjs from "@dayjs";
import { useLocale, useTranslations } from "next-intl";
import React from "react";

interface DateInputProps {
  departOnly?: boolean;
  departDate: string;
  returnDate: string;
  onClickDepart: () => void;
  onClickReturn: () => void;
}

const DateInput: React.FC<DateInputProps> = ({
  departOnly = false,
  departDate,
  returnDate,
  onClickDepart,
  onClickReturn,
}) => {
  const t = useTranslations();
  const locale = useLocale();

  const formatDisplayDate = (date: string): string => {
    if (!date) return "";

    return dayjs(date)
      .locale(locale)
      .format(locale === "en" ? "ddd, MMM D" : "YYYY-MM-DD");
  };
  return (
    <div className="flex gap-2 flex-grow">
      <label
        className="flex items-center rounded-lg border border-sleap-gray-400 flex-grow cursor-pointer"
        onClick={onClickDepart}
      >
        <span className="font-medium text-inter text-base text-sleap-gray-950 dark:text-white pl-4">
          {t("Other.depart")}
        </span>
        <input
          type="text"
          readOnly
          className="px-2 py-4 min-h-14 outline-none w-full rounded-lg text-inter text-base bg-transparent"
          value={
            departDate ? formatDisplayDate(departDate) : t("Other.selectDate")
          }
        />
      </label>

      {!departOnly && (
        <label
          className="flex items-center rounded-lg border border-sleap-gray-400 flex-grow cursor-pointer"
          onClick={onClickReturn}
        >
          <span className="font-medium text-inter text-base text-sleap-gray-950 dark:text-white pl-4">
            {t("Other.return")}
          </span>
          <input
            type="text"
            readOnly
            className="px-2 py-4 min-h-14 outline-none w-full rounded-lg text-inter text-base bg-transparent"
            value={returnDate ? formatDisplayDate(returnDate) : t("Other.any")}
            disabled={!departDate}
          />
        </label>
      )}
    </div>
  );
};

export default DateInput;
